var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 362,
    viewBox: "0 0 362 362",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.355 0.64502L193.909 106.451C197.775 139.035 223.465 164.725 256.049 168.591L361.855 181.145L256.049 193.699C223.465 197.565 197.775 223.255 193.909 255.839L181.355 361.645L168.801 255.839C164.935 223.255 139.245 197.565 106.661 193.699L0.85498 181.145L106.661 168.591C139.245 164.725 164.935 139.035 168.801 106.451L181.355 0.64502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.716e800b6942f8da9f55c1aa5dadac4e.svg";
export { ForwardRef as ReactComponent };